export const FONT_SIZE_OVERRIDE = `font-size: 16px;`;
